import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { filter, map } from "rxjs";
import { hasAnyPagePermission } from "../../access-control/page-permissions/page-permissions";
import { pagePermissions } from "../../access-control/page-permissions/page-permissions.selectors";
import { NavigationMenuService } from "../../navigation/navigation-menu.service";
import { ROLE_ASSIGNMENT_REQUIRED_ROUTE, resolveLandingPageUrl } from "../landing-page/resolve-landing-page-url";

export const landingPageRedirectGuard: CanActivateFn = () => {
    const globalStore = inject(Store);
    const router = inject(Router);
    const navigationMenuService = inject(NavigationMenuService);

    return globalStore.select(pagePermissions).pipe(
        filter((permissions) => permissions !== undefined),
        map((permissions) => {
            if (!permissions) {
                return false;
            }

            // Users without a recognized role receive no page permissions, so show the role-assignment notice.
            if (!hasAnyPagePermission(permissions)) {
                return router.createUrlTree(ROLE_ASSIGNMENT_REQUIRED_ROUTE);
            }

            return resolveLandingPageUrl(navigationMenuService.userNavigationMenu(), router);
        }),
    );
};
